export enum UserViewStatus {
    'NEW' = 'new',
    'READ' = 'read',
    'UPDATED' = 'updated',
}
